import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthService } from '../../core';
import { UsuarioPerfil, usuarioPerfilAdministrador } from './usuario-perfil';

/** Acessos permitidos ao cadastro de usuários */
export const acessosUsuario: UsuarioPerfil[] = [usuarioPerfilAdministrador];

@Injectable()
export class CanActivateUsuario implements CanActivateChild {

    constructor(private authService: AuthService) { }

    canActivateChild(): boolean {
        const usuario = this.authService.getUsuario();
        return !!usuario && usuario.acessoUsuarios;
    }
}
